/* Require from package.json */

global.jQuery = require('jquery');

global.$ = global.jQuery;

/**
 * Make sure to require 'vue/dist/vue.js' and not 'Vue', since 'Vue' will throw the error:
 * "You are using the runtime-only build of Vue where the template compiler is not available.
 *  Either pre-compile the templates into render functions, or use the compiler-included build."
 */

global.Vue = require('vue/dist/vue.js');

global.VueMatchHeights = require('vue-match-heights');

require('./partials/loadSidebar.js');
